module.exports = __webpack_public_path__ + "static/media/Simone.609301ae.png";